import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const InstructionsSkeleton = () => {
  return (
    <div className="instructions-skeleton-wrap" style={{ width: '100%', marginTop: 8 }}>
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <Skeleton.Input active style={{ width: 220, height: 28, borderRadius: 4 }} />
        <Skeleton.Input active style={{ width: 240, height: 38, borderRadius: 6 }} />
      </div>

      {/* Document Catalog Table */}
      <Card
        bordered={false}
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          overflow: 'hidden',
          background: '#ffffff',
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #eaedf1',
            padding: '12px 18px',
            gap: 12,
          }}
        >
          <div style={{ width: '8%' }}><Skeleton.Input active size="small" style={{ width: 24, height: 14 }} /></div>
          <div style={{ width: '42%' }}><Skeleton.Input active size="small" style={{ width: '60%', height: 14 }} /></div>
          <div style={{ width: '20%' }}><Skeleton.Input active size="small" style={{ width: '50%', height: 14 }} /></div>
          <div style={{ width: '18%' }}><Skeleton.Input active size="small" style={{ width: '50%', height: 14 }} /></div>
          <div style={{ width: '12%' }}><Skeleton.Input active size="small" style={{ width: '40%', height: 14 }} /></div>
        </div>

        {Array.from({ length: 7 }).map((_, idx) => (
          <div
            key={'inst_row_' + idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '14px 18px',
              borderBottom: idx === 6 ? 'none' : '1px solid #f1f5f9',
              backgroundColor: idx % 2 === 1 ? '#fafbfc' : '#ffffff',
              gap: 12,
            }}
          >
            <div style={{ width: '8%' }}>
              <Skeleton.Input active size="small" style={{ width: 24, height: 14, borderRadius: 2 }} />
            </div>
            <div style={{ width: '42%', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Skeleton.Avatar active size={28} shape="square" style={{ borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: '' + (60 + (idx * 5) % 35) + '%', height: 15, borderRadius: 3 }} />
            </div>
            <div style={{ width: '20%' }}>
              <Skeleton.Input active size="small" style={{ width: 80, height: 14, borderRadius: 3 }} />
            </div>
            <div style={{ width: '18%' }}>
              <Skeleton.Button active size="small" style={{ width: 70, height: 22, borderRadius: 6 }} />
            </div>
            <div style={{ width: '12%' }}>
              <Skeleton.Button active size="small" style={{ width: 80, height: 28, borderRadius: 4 }} />
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default InstructionsSkeleton;

